import { render } from "./reviewTasksListCompany.vue?vue&type=template&id=51860be6&scoped=true"
import script from "./reviewTasksListCompany.vue?vue&type=script&lang=js"
export * from "./reviewTasksListCompany.vue?vue&type=script&lang=js"

import "./reviewTasksListCompany.vue?vue&type=style&index=0&id=51860be6&scoped=true&lang=scss"

import exportComponent from "H:\\Environment_蓝宇\\Src\\GZXY\\GZEUA\\GZ_CQ_V2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51860be6"]])

export default __exports__